module.exports = __webpack_public_path__ + "img/BDCIcon5.fc3c57fd.png";